import { Theme } from '@mui/material';
import { ActivityMessage } from 'src/components/ActivityList/activity-list-item';
import { BoldText } from 'src/components/ActivityList/styled/bold-text';
import { ActivityFeed } from 'src/graphql/entities/activity-feed/hooks/use-activity-feed';
import { getCustomAddressFieldMessage } from './get-custom-address-field-message';

export const buildAddressMessage = (activity: ActivityFeed): ActivityMessage[] => {
  const actorName = activity.actor?.name?.trim() || '<Platform User>';

  switch (activity.activityType) {
    case 'create':
      return [
        {
          id: activity.id,
          icon: 'flare',
          color: (theme: Theme) => theme.palette.custom.OV.sys.primary,
          message: `${actorName} created the site`,
          timestamp: activity.timestamp,
        },
      ];
    case 'update':
      return activity.changes
        .filter(({ value, previousValue, skip }) => value !== previousValue && !skip)
        .map((activityChange) => {
          const { name, value, previousValue } = activityChange;
          const customMessage = getCustomAddressFieldMessage(activityChange, activity);
          if (!!value && !!previousValue) {
            return {
              id: `${activity.id}-${name}`,
              icon: 'edit_attributes',
              color: (theme: Theme) => theme.palette.custom.OV.sys.tertiary,
              message: customMessage || (
                <>
                  {actorName} changed the <BoldText>{name}</BoldText> from{' '}
                  <BoldText>&quot;{previousValue}&quot;</BoldText> to{' '}
                  <BoldText>&quot;{value}&quot;</BoldText>
                </>
              ),
              timestamp: activity.timestamp,
            };
          } else if (!!value && !previousValue) {
            return {
              id: `${activity.id}-${name}`,
              icon: 'edit_attributes',
              color: (theme: Theme) => theme.palette.custom.OV.sys.tertiary,
              message: customMessage || (
                <>
                  {actorName} changed the <BoldText>{name}</BoldText> to{' '}
                  <BoldText>&quot;{value}&quot;</BoldText>
                </>
              ),
              timestamp: activity.timestamp,
            };
          } else if (!value && !!previousValue) {
            return {
              id: `${activity.id}-${name}`,
              icon: 'edit_attributes',
              color: (theme: Theme) => theme.palette.custom.OV.sys.tertiary,
              message: customMessage || (
                <>
                  {actorName} unset the <BoldText>{name}</BoldText> from{' '}
                  <BoldText>&quot;{previousValue}&quot;</BoldText>
                </>
              ),
              timestamp: activity.timestamp,
            };
          }
          return null;
        })
        .filter((value) => !!value);
    case 'delete': {
      return [
        {
          id: activity.id,
          icon: 'delete',
          color: (theme: Theme) => theme.palette.custom.OV.sys.primary,
          message: `${actorName} deleted the site`,
          timestamp: activity.timestamp,
        },
      ];
    }
    default:
      return [];
  }
};
